import { useState, useEffect, useCallback } from 'react';

import UploadModal from '../components/modal/uploadModal'

import { ReactComponent as Arrow } from '../assets/icons/left_arrow.svg';

import classes from '../styles/components/uploadButtons.module.scss';
import sheet from '../styles/components/answerSheet.module.scss';
import { formatAnswerSheetQuestionNo, getAnswerFilesDisplay, getAnswerFiles } from '../assets/utils/utils';
import ForwardOnlySheetModal from './modal/forwardOnlySheetModal';


const UploadButtons = ({
    index,
    quNo,
    userAnswered,
    attemptID,
    score,
    activeBtn,
    activeBtnHandler,
    nullingActiveBtnHandler,
    answerAttemptRes,
    onAnswerUpdated,
    onAnswerSaved,
    questionBody,
    question,
    questionImage,
    questionVoice,
    /** active | past_answered | past_unanswered | future — فقط برای پاسخ‌نامه در حالت تکی بدون بازگشت */
    answerSheetMode = 'active',
    /** در حالت فقط جلو: همیشه ردیف سوال جاری در پاسخ‌نامه برجسته بماند (حتی بعد بستن مودال) */
    answerSheetPrimaryQuestionId = null,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [body, setBody] = useState("")
    const [uploadedFileName, setUploadedFileName] = useState("")
    const [buttonValue, setButtonValue] = useState("(کلیک کنید)")
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [forwardOnlyInfo, setForwardOnlyInfo] = useState(null)


    function answerAttemptResHandler(data){
        answerAttemptRes(data);
    }

    const modalHandler = () => {
        nullingActiveBtnHandler()
        if (isModalOpen) setIsModalOpen(false);
        else if (!isModalOpen) setIsModalOpen(true)
    }

    const handleAnswerSheetClick = () => {
        if (answerSheetMode === 'future') {
            setForwardOnlyInfo('future');
            return;
        }
        if (answerSheetMode === 'past_unanswered') {
            setForwardOnlyInfo('locked');
            return;
        }
        if (answerSheetMode === 'past_answered') {
            setIsModalOpen(true);
            activeBtnHandler(index);
        }
    }

    const setBodyData = (data) => {
        setBody(data)
    }

    const uploadSuccess = () => {
        setButtonValue("فایل آپلود شد");
    }

    const uploadFileName = (fileName) => {
        setButtonValue(fileName);
        setUploadedFileName(fileName);
    }

    const handleUploadedFilesChange = (files) => {
        setUploadedFiles(files || []);
        const display = files?.length > 1
            ? `${files.length} فایل آپلود شد`
            : (files?.[0]?.original_name || null);
        if (display) {
            uploadFileName(display);
        }
    }

    const userAnsweredHandler = useCallback((qid) => {
        for (var i = 0; i < userAnswered?.length; i++) {
            if (qid === userAnswered[i]?.id) {
                const item = userAnswered[i];
                const display = getAnswerFilesDisplay(item);
                if (display) {
                    uploadFileName(display);
                } else if (item?.answer) {
                    uploadFileName("پاسخ تشریحی ثبت شد.");
                }
                if (item?.answer) {
                    setBody(item.answer);
                }
                setUploadedFiles(getAnswerFiles(item) || []);
            }
        }
    }, [userAnswered]);

    const handleFileDeleted = () => {
        onAnswerUpdated?.();
    }

    useEffect(() => {
        userAnswered && userAnsweredHandler(index);
    }, [userAnswered, index, userAnsweredHandler]);

    const isAnswerSheetRowFocused =
        activeBtn === index
        || (
            answerSheetMode === 'active'
            && answerSheetPrimaryQuestionId != null
            && answerSheetPrimaryQuestionId === index
            && (activeBtn == null || activeBtn === answerSheetPrimaryQuestionId)
        );

    return (

        // <li className={classes.uploadRow}>
        <li key={index} className={classes.uploadButtonRow} style={{ paddingRight: 0 }}>
            <ForwardOnlySheetModal
                isOpen={forwardOnlyInfo !== null}
                onClose={() => setForwardOnlyInfo(null)}
                title={forwardOnlyInfo === 'future' ? `سوال ${quNo}` : forwardOnlyInfo === 'locked' ? `سوال ${quNo}` : ''}
                text={
                    forwardOnlyInfo === 'future'
                        ? 'هنوز به این سوال نرسیده‌اید. ابتدا با دکمه «سوال بعدی» جلو بروید؛ تا رسیدن نوبت این سوال، پاسخ‌نامه این بخش باز نمی‌شود.'
                        : forwardOnlyInfo === 'locked'
                            ? 'به‌دلیل حالت «فقط رو به جلو» دیگر امکان ثبت یا ویرایش پاسخ برای این سوال وجود ندارد. در زمان رسیدن به این سوال پاسخی ثبت نشده بود.'
                            : undefined
                }
            />
            {
                isModalOpen &&
                <UploadModal id={index} quNo={quNo} body={body} uploadedFileName={uploadedFileName} uploadedFiles={uploadedFiles}
                    answerAttemptRes={answerAttemptResHandler} attemptID={attemptID} onConfirm={modalHandler} setBodyData={setBodyData}
                    uploadSuccess={uploadSuccess} uploadFileName={uploadFileName} onFileDeleted={handleFileDeleted}
                    onAnswerUpdated={onAnswerUpdated}
                    onAnswerSaved={onAnswerSaved}
                    onUploadedFilesChange={handleUploadedFilesChange}
                    questionBody={questionBody}
                    question={question}
                    questionImage={questionImage}
                    questionVoice={questionVoice}
                    viewOnly={answerSheetMode === 'past_answered'}
                />
            }
            <div className={`${sheet.sheetRow} ${isAnswerSheetRowFocused ? sheet.sheetRowCurrent : ''}`}>
                <span className={sheet.questionNo}>{formatAnswerSheetQuestionNo(quNo)}</span>
                <div
                    className={`${sheet.descriptiveBtnWrap} ${classes.uploadBtn_container} ${isAnswerSheetRowFocused && classes.active_uploadBtn}`}
                    onClick={() => {
                        if (answerSheetMode === 'active') {
                            setIsModalOpen(true);
                            activeBtnHandler(index);
                            return;
                        }
                        handleAnswerSheetClick();
                    }}
                    style={{
                        ...(answerSheetMode === 'future' || answerSheetMode === 'past_unanswered' ? { cursor: 'pointer' } : {}),
                        width: '100%',
                        maxWidth: '100%',
                    }}
                >
                    <p className={`${classes.uploadBtn} uploadBtn-${index}`}>{buttonValue}</p>
                    <Arrow className={`${classes.arrow} ${isAnswerSheetRowFocused && classes.active_arrow}`} />
                </div>
                <div className={sheet.gradeCol}>
                    <span className={sheet.gradeValue}>{score}</span>
                    <span className={sheet.gradeLabel}>بارم</span>
                </div>
            </div>
        </li>
        // </li>
    )
}



export default UploadButtons;